{
  "label": "Разделы",
  "open": "Открыть меню",
  "collapse": "Свернуть меню",
  "expand": "Развернуть меню",
  "groups": {
    "project": "Проект",
    "infrastructure": "Инфраструктура",
    "services": "Сервисы",
    "observe": "Наблюдение",
    "org": "Организация"
  },
  "switcher": {
    "caption": "Проект",
    "title": "Выбор проекта",
    "search": "Найти проект",
    "list": "Проекты",
    "none": "Ничего не нашлось",
    "empty": "Проектов пока нет",
    "new": "Новый проект"
  },
  "overview": "Обзор",
  "dashboard": "Дашборд",
  "servers": "Серверы",
  "allServers": "Все серверы",
  "networking": "Сеть",
  "networks": "Частные сети",
  "firewalls": "Файрволы",
  "ips": "Публичные IP",
  "sshKeys": "SSH-ключи",
  "appsCatalogue": "Каталог",
  "appsInstalled": "Установленные",
  "kubernetes": "Kubernetes",
  "dns": "Домены и DNS",
  "monitoringServers": "Серверы (Автопилот)",
  "projectSettings": "Настройки проекта",
  "connection": "Подключение к провайдеру",
  "catalogue": "Каталог провайдера",
  "soon": "Скоро",
  "soonHint": "«{{name}}» скоро появится",
  "projects": "Все проекты",
  "security": "Вход и безопасность",
  "account": "Учётная запись",
  "theme": "Тема",
  "themes": {
    "system": "Как в системе",
    "light": "Светлая",
    "dark": "Тёмная"
  },
  "images": "Снимки и бэкапы",
  "volumes": "Диски",
  "floatingIps": "Плавающие IP",
  "placementGroups": "Группы размещения",
  "loadBalancers": "Балансировщики",
  "certificates": "Сертификаты",
  "users": "Пользователи",
  "projectAccess": "Участники",
  "guestNotice": "Вы гость в этом проекте: здесь можно всё смотреть, но ничего не менять.",
  "apiAccess": "API и интеграции",
  "apiKeys": "Ключи",
  "apiPolicies": "Политики",
  "apiApps": "Подключённые приложения",
  "messengers": "Мессенджеры",
  "apiApprovals": "Подтверждения",
  "apiDocs": "Документация API",
  "costs": "Расходы",
  "orgCosts": "Расходы организации",
  "alerts": "Оповещения",
  "monitoring": "Мониторинг",
  "apps": "Приложения"
}
